import React from "react";
import {
  AddToCart as SharedAddToCart,
  AddToCartProps as SharedAddToCartProps,
} from "~/features/shopping/ui";
import Error from "../Error";

type AddToCartProps = {
  error?: string;
} & SharedAddToCartProps;

const AddToCart = ({ error, ...rest }: AddToCartProps) => (
  <>
    <SharedAddToCart className="whitespace-nowrap" {...rest}>
      Add to Cart
    </SharedAddToCart>
    {error && <Error>{error}</Error>}
  </>
);

export default AddToCart;
